var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshot = function SvgScreenshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.188 3.36h-2.391l-.57-1.597a.562.562 0 0 0-.53-.372H5.303a.563.563 0 0 0-.53.372l-.57 1.596H1.812c-.777 0-1.407.63-1.407 1.407v8.015c0 .777.63 1.406 1.407 1.406h12.374c.777 0 1.407-.629 1.407-1.406V4.766c0-.777-.63-1.407-1.407-1.407zm.14 9.421a.14.14 0 0 1-.14.14H1.812a.14.14 0 0 1-.14-.14V4.766a.14.14 0 0 1 .14-.141h3.282l.3-.84.403-1.129h4.404l.402 1.129.3.84h3.284a.14.14 0 0 1 .141.14v8.016zM8 5.75a2.812 2.812 0 1 0-.001 5.625A2.812 2.812 0 0 0 8 5.75zm0 4.5a1.688 1.688 0 1 1 0-3.377 1.688 1.688 0 0 1 0 3.377z"
  })));
};
export default SvgScreenshot;